import enumify from '../constants/enumify';

export enum GoldenRecordsActionConfirmationTypeE {
  PUBLISH = 'PUBLISH',
  UPDATE = 'UPDATE',
  UPDATE_AND_PUBLISH = 'UPDATE_AND_PUBLISH'
}

export default enumify(GoldenRecordsActionConfirmationTypeE);
